import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        modalContent: {
            maxWidth: remCalc(640),
            p: ['small.base', 'small.sm', 'small.md', 'small.lg'],
            borderRadius: remCalc(12),
            bg: 'background.base.default',
        },
        modalHeader: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            padding: remCalc(0),
        },
        modalBody: {
            paddingInline: remCalc(0),
            paddingTop: remCalc(0),
            paddingBottom: remCalc(0),
        },
        closeButtonIcon: {
            width: remCalc(20),
            height: remCalc(20),
            color: 'foreground.neutral.default',
        },
        modalFooter: {
            paddingInline: remCalc(0),
            paddingTop: remCalc(16),
            paddingBottom: remCalc(0),
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            width: '100%',
        },
    },
}
